import axios from "axios";
import {
  getStoredToken,
  isTokenExpired,
  clearAuthAndRedirectToLogin,
} from "../utils/auth";

const WABA_API_BASE = process.env.REACT_APP_WABA_SERVER_URL;

const paymentsAPI = axios.create({
  baseURL: `${WABA_API_BASE}/api/payments`,
  headers: { "Content-Type": "application/json" },
});

paymentsAPI.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (!token || isTokenExpired(token)) {
    clearAuthAndRedirectToLogin();
    return Promise.reject(new Error("Token expired"));
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

paymentsAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthAndRedirectToLogin();
    }
    return Promise.reject(error);
  }
);

export const listPaymentConfigurations = (phoneId) => paymentsAPI.get(`/${phoneId}`);

export const listPaymentTransactions = (phoneId) =>
  paymentsAPI.get(`/${phoneId}/transactions`);

export const getPaymentConfiguration = (phoneId, name) =>
  paymentsAPI.get(`/${phoneId}/${encodeURIComponent(name)}`);

export const createPaymentConfiguration = (phoneId, payload) =>
  paymentsAPI.post(`/${phoneId}`, payload);

export const generatePaymentOauthLink = (phoneId, payload) =>
  paymentsAPI.post(`/${phoneId}/oauth-link`, payload);

export const sendPayment = (phoneId, payload) =>
  paymentsAPI.post(`/${phoneId}/send`, payload);
